import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useLocalizedNavigate from 'hooks/useLocalizedNavigate';
import { getUnlocalizedPath } from 'utils/localizedRouting';
import {
  LobbyIcon,
  OriginalsIcon,
  SlotsIcon,
  TableGamesIcon,
  LiveCasinoIcon,
  GameShowsIcon,
  NewGamesIcon,
  DiceIcon,
} from 'components/icons';
import styles from './subHeader.module.scss';

export const navItems = [
  {
    name: 'Lobby',
    key: 'lobby',
    icon: <LobbyIcon className={styles.icon_lobby} width="24" height="24" />,
  },
  {
    name: 'Originals',
    key: 'originals',
    icon: <OriginalsIcon className={styles.icon} width="20" height="20" />,
  },
  {
    name: 'Instant',
    key: 'instant',
    icon: <DiceIcon className={styles.icon} width="20" height="20" />,
  },
  {
    name: 'Slots',
    key: 'slots',
    icon: <SlotsIcon className={styles.icon} width="20" height="20" />,
  },
  {
    name: 'Table Games',
    key: 'tableGames',
    icon: <TableGamesIcon className={styles.icon} width="20" height="20" />,
  },
  {
    name: 'Live Casino',
    key: 'liveCasino',
    icon: <LiveCasinoIcon className={styles.icon} width="20" height="20" />,
  },
  {
    name: 'Game Shows',
    key: 'gameShows',
    icon: <GameShowsIcon className={styles.icon} width="20" height="20" />,
  },
  {
    name: 'New Games',
    key: 'newGames',
    icon: <NewGamesIcon className={styles.icon} width="20" height="20" />,
  },
];

const SubHeader: React.FC = () => {
  const navigate = useLocalizedNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const currentPath = getUnlocalizedPath(location.pathname);

  return (
    <div className={styles.subHeader}>
      <div className={styles.container}>
        <div className={styles.navGroup}>
          {navItems.map((item) => {
            const targetPath =
              item.name === 'Lobby'
                ? '/'
                : `/casino/categories/${item.name.toLowerCase().replace(/\s+/g, '_')}`;

            const isActive =
              currentPath === targetPath ||
              (item.name === 'Lobby' && (currentPath === '/' || currentPath === '/home'));

            return (
              <button
                key={item.name}
                className={`${styles.navItem} ${isActive ? styles.active : ''}`}
                onClick={() => navigate(targetPath)}
              >
                {item.icon}
                {t(`common.${item.key}`, t(`nav.${item.key}`, item.name))}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SubHeader;
